import { createMessage } from './createMessage';
import { MessageType } from './messageTypes';
export class EventBus {
    log(...data) {
        this.enableLog && console.log(...data);
    }
    get isConnected() {
        return !!this.connection;
    }
    isTargetIframe() {
        try {
            return !!this.connection.contentWindow;
        }
        catch (e) {
            return false;
        }
    }
    constructor(targetOrigin, enableLog = false) {
        this.listeners = [];
        this.messageListener = (messageEvent) => {
            const { data: message } = messageEvent;
            if (this.targetOrigin !== messageEvent.origin) {
                return;
            }
            if (!message.type) {
                return;
            }
            this.log('<<<< Event bus received a message', message);
            this.listeners
                .filter(([type]) => type === message.type)
                .forEach(([, handler]) => handler(message));
        };
        this.targetOrigin = targetOrigin;
        this.enableLog = enableLog;
        0;
    }
    get connectedTargetOrigin() {
        return this.targetOrigin;
    }
    disconnect() {
        this.send(createMessage(MessageType.close));
        this.connection = undefined;
        this.targetOrigin = '';
        this.listeners = [];
        window.removeEventListener('message', this.messageListener);
    }
    connect(target, callback) {
        if (!target) {
            throw 'Target object must be provided!';
        }
        this.connection = target;
        window.addEventListener('message', this.messageListener);
        if (callback) {
            this.log('<<<< Target connection established!');
            callback();
        }
        return this;
    }
    send(message) {
        var _a, _b;
        if (this.isConnected && this.targetOrigin) {
            try {
                if (this.isTargetIframe()) {
                    (_a = this.connection.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(message, this.targetOrigin);
                }
                else {
                    (_b = this.connection) === null || _b === void 0 ? void 0 : _b.postMessage(message, this.targetOrigin);
                }
            }
            catch (e) {
                throw 'Could not send the message!' + e;
            }
        }
        else {
            throw `Could not send message: ${message.type}. No active connection!`;
        }
    }
    on(messageType, handler) {
        this.listeners.push([messageType, handler]);
    }
}
//# sourceMappingURL=eventBus.js.map